import React, { useEffect, useState } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { CustomComponentEditor } from './CustomComponentEditor';
import { CustomComponentCDNs } from './CustomComponentCDNs';
import CommonPageComponent from '../../../common/ui/CommonPageComponent';
import CustomLoader from '../../common/CustomLoader';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import showAlert from '../../../common/utils/alert';
import { Field, Form, Formik } from 'formik';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { CustomModal } from '../../../common/ui/CustomModal';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import CustomInputWithIconNoFormGroup from '../../../common/ui/CustomInputWithIconNoFormGroup';
import { BASE_AI_MODELS, createRedirectUrl } from '../../../common/utils/prompt-constants';
import { toast } from 'react-toastify';
import { handleGenerateComponent, extractCdns, tooltipDetails } from './utils.js';

export const CustomComponentEditForm = ({
  projectId,
  version,
  component,
  customComponentId,
  history,
  collections,
  projectDetail,
  pages,
  events,
  loadCustomComponentConfigPending,
  actions,
}) => {
  if (loadCustomComponentConfigPending || !component) {
    return (
      <CommonPageComponent parentClassName="">
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
            <CustomLoader loading={loadCustomComponentConfigPending} size="20px" color="#303453" />
          </div>
        </div>
      </CommonPageComponent>
    );
  }

  const [isGenerateModal, setIsGenerateModal] = useState(false);
  const [isDefaultAiModel, setIsDefaultAiModel] = useState('');
  const [isSelectedModel, SetIsSelectedMOdel] = useState('');
  const [generateComponentPending, setGenerateComponentPending] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [name, setName] = useState('');
  const [collectionName, setCollectionName] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [customCSS, setCustomCSS] = useState('');
  const [customJS, setCustomJS] = useState('');
  const [customCssCdns, setCustomCssCdns] = useState([]);
  const [customJsCdns, setCustomJsCdns] = useState([]);

  useEffect(() => {
    setName(component.name);
    setCollectionName(component.collectionName);
    setHtmlContent(component.content.htmlContent);
    setCustomCSS(component.content.customCSS);
    setCustomJS(component.content.customJS);
    setCustomCssCdns(component.customCssCdns);
    setCustomJsCdns(component.customJsCdns);
  }, []);

  const {
    updateCustomComponentConfig,
    addCustomComponentCssCdn,
    deleteCustomComponentCssCdn,
    updateCustomComponentCssCdn,
    addCustomComponentJsCdn,
    deleteCustomComponentJsCdn,
    updateCustomComponentJsCdn,
    deleteCustomComponentConfig,
    generateCustomComponent,
  } = actions;

  const collectionOptions = collections.map((coll) => ({
    value: coll.collectionName,
    label: coll.collectionTitle,
  }));
  const handleUpdateComponent = (updateFields) => {
    const updatedData = {
      projectId,
      version,
      uuid: customComponentId,
      ...updateFields,
    };
    updateCustomComponentConfig(updatedData);
  };
  const handleCollectionSubmit = () => {
    handleUpdateComponent({
      collectionName,
    });
  };
  const handleCustomJsSubmit = () => {
    handleUpdateComponent({
      customJS,
    });
  };
  const handleHtmlContentSubmit = () => {
    handleUpdateComponent({
      htmlContent,
    });
  };
  const handleCustomCssSubmit = () => {
    handleUpdateComponent({
      customCSS,
    });
  };
  const handleNameSubmit = () => {
    handleUpdateComponent({
      name,
    });
    setIsOpenModal(false);
  };

  const validateCssUrl = (value) => {
    if (!value || value.length === 0) {
      return 'URL or a <link> tag is required';
    }
    const urlRegEx =
      /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (!urlRegEx.test(value)) {
      if (!value.startsWith('<link') || !value.includes('href')) {
        return 'Not a valid URL or a <link> tag';
      }
    }
  };
  const validateJsUrl = (value) => {
    if (!value || value.length === 0) {
      return 'URL or a <script> tag is required';
    }
    const urlRegEx =
      /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (!urlRegEx.test(value)) {
      if (!value.startsWith('<script') || !value.includes('src')) {
        return 'Not a valid URL or a <script> tag';
      }
    }
  };

  const handleDelete = (uuid) => {
    const preConfirm = () =>
      deleteCustomComponentConfig({ projectId, uuid: customComponentId, version }).then(() =>
        history.goBack(),
      );
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  const modifyButton = () => {
    return (
      <UncontrolledDropdown group className="custom-pad-right-1 pr-2">
        <DropdownToggle color="theme-warning" title="Modify" className="btn-md" caret>
          <i className="wb webconnect-cogs"></i> Modify
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => setIsOpenModal(true)} className="theme-green">
            <i className="wb webconnect-pencil"></i>&nbsp;Update Component Name
          </DropdownItem>
          <DropdownItem onClick={handleDelete} className="theme-red">
            <i className="wb webconnect-trash-regular"></i>&nbsp;Delete Component
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };

  const generateComponentButton = () => {
    return (
      <div className="custom-pad-right-1 pr-2 btn-group">
        <button
          type="button"
          style={{ height: '40px' }}
          className="btn btn-primary btn-md"
          onClick={() => setIsGenerateModal(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            width="16"
            height="16"
            className="mr-1"
            style={{ verticalAlign: 'middle', fill: 'white' }}
          >
            <path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z" />
          </svg>
          Generate Component&nbsp;
        </button>
      </div>
    );
  };
  const showModal = () => {
    return (
      <CustomModal
        isOpen={isOpenModal}
        toggle={() => setIsOpenModal(!isOpenModal)}
        size="lg"
        header={'Update Custom Component Name'}
        bodyClasses={'text-center'}
        footerClasses={'d-flex justify-content-center'}
        body={
          <Formik>
            {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <CustomInputWithIcon icon="text" required={true}>
                        <Field
                          type="text"
                          name="name"
                          placeholder="Name"
                          className="form-control form-control-sm"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </CustomInputWithIcon>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        }
        footer={
          <div className="col-md-12 col-lg-12 mt-2 text-right">
            <button
              type="button"
              className="btn btn-default btn-md"
              onClick={() => setIsOpenModal(!isOpenModal)}
            >
              <span>
                <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
              </span>
            </button>
            &nbsp;
            <button className="btn btn-theme-submit btn-md" onClick={handleNameSubmit}>
              <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update&nbsp;
            </button>
          </div>
        }
      />
    );
  };

  const handleGenerateSubmit = async (values) => {
    try {
      setGenerateComponentPending(true);
      const selectedModelType = isSelectedModel || 'OPEN_AI';
      const aiModelConfig =
        (projectDetail.aiModelConfigs || []).find((cfg) => cfg.modelType === selectedModelType) ||
        {};
      const apiKey =
        (aiModelConfig && aiModelConfig.setting && aiModelConfig.setting.secretKey) || '';
      const modelType =
        (aiModelConfig && aiModelConfig.setting && aiModelConfig.setting.modelType) ||
        selectedModelType;
      const extractUrlJSCdns = extractCdns(customJsCdns);
      const extractUrlCssCdns = extractCdns(customCssCdns);
      const userPrompt = `        ${values.promptText}
          ${htmlContent ? `\n---\nHTML:\n${htmlContent}` : ''}
          ${customCSS ? `\n---\nCSS:\n${customCSS}` : ''}
          ${customJS ? `\n---\nJS:\n${customJS}` : ''}
       "existingJsCdns":${extractUrlCssCdns ? `\n---\nJS:\n${extractUrlCssCdns}` : ''}
        "existingCssCdns":${extractUrlJSCdns ? `\n---\nJS:\n${extractUrlJSCdns}` : ''}
          `.trim();

      const args = {
        generatedCodeConfig: 'custom_component',
        generationType: 'create',
        userPrompt: userPrompt,
        apiKey,
        aiModel: modelType,
        projectId,
        version,
      };
      const generatedContent = await handleGenerateComponent(
        generateCustomComponent,
        args,
        setHtmlContent,
        setCustomCSS,
        setCustomJS,
        customComponentId,
        addCustomComponentCssCdn,
        addCustomComponentJsCdn,
        customCssCdns,
        customJsCdns,
      );
      setIsGenerateModal(false);
      toast.success('Component content generated successfully!');
    } catch (error) {
      console.error('Error generating component content:', error);
      toast.error('Error generating component content. Please try again.');
    } finally {
      setGenerateComponentPending(false);
    }
  };

  const showGenerateComponentModal = () => {
    let hasEnabledAIModelConfigs = false;
    let modelOptions = [];
    if (projectDetail && projectDetail.aiModelConfigs) {
      const enabledConfigs = projectDetail.aiModelConfigs.filter((cfg) => cfg.isEnabled);
      const defaultConfig = enabledConfigs.find((cfg) => cfg.isDefault);
      if (enabledConfigs.length > 0) {
        if (defaultConfig) {
          const base = BASE_AI_MODELS.find((opt) => opt.value === defaultConfig.modelType);
          const defaultAIModel = {
            label: base.label || defaultConfig.modelType,
            value: defaultConfig.modelType,
          };
          if (!isSelectedModel) {
            setIsDefaultAiModel(defaultAIModel.value);
            SetIsSelectedMOdel(defaultAIModel.value);
          }
        }
        hasEnabledAIModelConfigs = true;
        modelOptions = enabledConfigs.map((cfg) => {
          const base = BASE_AI_MODELS.find((opt) => opt.value === cfg.modelType);
          return {
            label: base.label || cfg.modelType,
            value: cfg.modelType,
          };
        });
      }
    }
    let redirectUrl = createRedirectUrl();
    let aiModelConfigurationURL = `${redirectUrl}app-setting/${version}/v/${projectId}/setting/aiModelConfig-section`;

    return (
      <CustomModal
        isOpen={isGenerateModal}
        toggle={() => setIsGenerateModal(!isGenerateModal)}
        size="lg"
        header={'Generate Custom Component '}
        bodyClasses={'text-center'}
        footerClasses={'d-flex justify-content-center'}
        body={
          <Formik
            initialValues={{ aiModel: isDefaultAiModel ? isDefaultAiModel : '', promptText: '' }}
          >
            {({ values, setFieldValue }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <CustomInputWithIcon icon="text" required={true}>
                        <Field
                          type="text"
                          name="promptText"
                          placeholder="Please Tell About Your Component..."
                          className="form-control form-control-sm"
                          onChange={(e) => setFieldValue('promptText', e.target.value)}
                        />
                      </CustomInputWithIcon>
                      <CustomInputWithIconNoFormGroup
                        icon="dropdown"
                        title="Select AI Model"
                        required={true}
                      >
                        <CustomSelect
                          name="aiModel"
                          isMulti={false}
                          options={modelOptions}
                          value={values.aiModel}
                          onChange={setFieldValue}
                          onChangeValue={(name, value) => SetIsSelectedMOdel(value)}
                          menuPlacement="top"
                          classNamePrefix="select"
                        />
                      </CustomInputWithIconNoFormGroup>
                    </div>
                  </div>
                  {!hasEnabledAIModelConfigs && (
                    <div className="text-danger mt-4 ml-6">
                      <i className="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                      Please configure the AI model in the{' '}
                      <a
                        href={aiModelConfigurationURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <span style={{ textDecoration: 'underline' }}>AI Model Configuration</span>
                        <i className="fa fa-external-link-alt ml-1" aria-hidden="true"></i>
                      </a>{' '}
                      section.
                    </div>
                  )}

                  <div className="col-md-12 col-lg-12 mt-3 text-right">
                    <button
                      type="button"
                      className={`btn btn-md ${
                        !isSelectedModel ||
                        !hasEnabledAIModelConfigs ||
                        !values.promptText ||
                        generateComponentPending
                          ? 'btn-default'
                          : 'btn-theme-submit'
                      }`}
                      onClick={() => handleGenerateSubmit(values)}
                      disabled={
                        !isSelectedModel ||
                        !hasEnabledAIModelConfigs ||
                        !values.promptText ||
                        generateComponentPending
                      }
                    >
                      <i className="wb webconnect-rocket"></i> &nbsp;Generate
                      <CustomLoader loading={generateComponentPending} />
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        }
      />
    );
  };

  return (
    <>
      {showModal()}
      {showGenerateComponentModal()}
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <ParentCardNoCol
          title="Custom Component"
          icon="customComponent"
          bgColor="drapcode-violet"
          CtaComponent={modifyButton()}
          generateComponentButton={generateComponentButton()}
        >
          <Formik enableReinitialize={true} initialValues={{}} onSubmit={handleCollectionSubmit}>
            {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <FormFieldWithLabel cta={false} label={'Name'} icon={'text'}>
                        <Field
                          type="text"
                          name="customComponentName"
                          className="form-control form-control-sm"
                          value={name}
                          readOnly
                        />
                      </FormFieldWithLabel>
                    </div>
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <FormFieldWithLabel cta={false} label={'Collection'} icon={'select'}>
                        <CustomSelect
                          name={'collectionName'}
                          isMulti={false}
                          value={collectionName ? collectionName : ''}
                          options={collectionOptions}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          onChangeValue={(name, value) => setCollectionName(value)}
                          placeholder={'Collection'}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 mt-2 text-right">
                    <button type="submit" className="btn btn-theme-submit btn-md">
                      <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update&nbsp;
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </ParentCardNoCol>
        {customCssCdns && (
          <CustomComponentCDNs
            projectId={projectId}
            version={version}
            customComponentId={customComponentId}
            cdns={component.customCssCdns}
            validateUrl={validateCssUrl}
            title={'CSS URL or Link Tag'}
            onSubmit={addCustomComponentCssCdn}
            onDelete={deleteCustomComponentCssCdn}
            onUpdate={updateCustomComponentCssCdn}
          />
        )}
        {customJsCdns && (
          <CustomComponentCDNs
            projectId={projectId}
            version={version}
            customComponentId={customComponentId}
            cdns={component.customJsCdns}
            validateUrl={validateJsUrl}
            title={'JS URL or Script Tag'}
            onSubmit={addCustomComponentJsCdn}
            onDelete={deleteCustomComponentJsCdn}
            onUpdate={updateCustomComponentJsCdn}
          />
        )}
        <CustomComponentEditor
          title={'Html Code'}
          icon={'htmlContent'}
          value={htmlContent}
          mode={'html'}
          showTooltip={false}
          tooltipTitle={``}
          tooltipDescription={``}
          collectionName={collectionName}
          collections={collections}
          projectDetail={projectDetail}
          pages={pages}
          showDynamicOptions={true}
          events={events}
          onChange={(value) => setHtmlContent(value)}
          onSubmit={handleHtmlContentSubmit}
        />
        <CustomComponentEditor
          title={'CSS Code'}
          icon={'customCss'}
          value={customCSS}
          mode={'css'}
          showTooltip={false}
          tooltipTitle={``}
          tooltipDescription={``}
          onChange={(value) => setCustomCSS(value)}
          onSubmit={handleCustomCssSubmit}
          showDynamicOptions={true}
        />
        <CustomComponentEditor
          title={'JavaScript Code'}
          icon={'customJS'}
          value={customJS}
          mode={'javascript'}
          showTooltip={true}
          tooltipTitle={`Custom Component's Best Practices`}
          tooltipDescription={tooltipDetails('javascript')}
          tooltipMaxWidth={550}
          collectionName={collectionName}
          collections={collections}
          projectDetail={projectDetail}
          pages={pages}
          events={events}
          showDynamicOptions={true}
          onChange={(value) => setCustomJS(value)}
          onSubmit={handleCustomJsSubmit}
        />
      </div>
    </>
  );
};
